import type { ApiClient } from '../client';
import { UserDeliveriesResponseSchema, type UserDeliveriesResponse } from '../schemas/deliveries';

export async function fetchUserDeliveries(
  client: ApiClient,
  id: string,
): Promise<UserDeliveriesResponse> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/users/${encodeURIComponent(id)}/deliveries`,
  );
  return UserDeliveriesResponseSchema.parse(data);
}
